import React from 'react';
import { CheckCircleIcon, WrenchIcon, ArrowRightIcon } from 'lucide-react';
export function TopicsSection() {
  const topics = ['Lectura de diagramas eléctricos', 'Circuitos de mando y potencia', 'Contactores y relés', 'Lógica de control', 'Montaje de tableros', 'Diagnóstico de fallas'];
  return <section className="bg-cream py-8 px-4" data-id="element-429">
      <div className="max-w-[600px] mx-auto" data-id="element-430">
        <h2 className="text-[24px] text-center font-bold text-brand-black mb-8 leading-[1.2] heading-underline flex items-center justify-center gap-2" data-id="element-431">
          <WrenchIcon className="w-6 h-6 text-primary" data-id="element-432" />
          TIPOS DE CONOCIMIENTO QUE DOMINARÁS
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-433">
          {topics.map((topic, index) => <div key={index} className="flex items-center gap-3 bg-brand-black-light border border-white/10 rounded-lg p-3 shadow-sm" data-id="element-434">
              <CheckCircleIcon className="w-5 h-5 text-success flex-shrink-0" data-id="element-435" />
              <span className="text-dark-gray text-sm font-medium" data-id="element-436">
                {topic}
              </span>
            </div>)}
        </div>

        <div className="text-center bg-primary/10 border border-primary/20 rounded-lg p-4 flex items-center justify-center gap-2" data-id="element-437">
          <p className="text-primary font-bold text-lg m-0 flex items-center gap-2" data-id="element-438">
            Y lo más importante: cómo conectar todo eso en la vida real
            <ArrowRightIcon className="w-5 h-5" data-id="element-439" />
          </p>
        </div>
      </div>
    </section>;
}